<template>
  <section id="landing-hero" class="bg-white">
    <div class="relative isolate">
      <div
        class="mx-auto max-w-7xl px-6 pt-32 pb-24 sm:py-32 lg:flex lg:items-center lg:gap-x-10 lg:px-8 lg:py-40"
      >
        <div class="mx-auto max-w-2xl lg:mx-0 lg:flex-auto">
          <h1
            class="text-5xl font-semibold tracking-tight text-pretty text-gray-800 sm:text-7xl"
          >
            <span class="inline-block relative">
              <img
                src="/graphics/green/burst-1.svg"
                alt="Burst squiggle"
                class="absolute -left-10 -top-6 w-12"
                height="16"
                width="48"
              />
              Everything
            </span>
            you need to <TextUnderline>manage</TextUnderline> your classroom
          </h1>
          <p
            class="mt-8 text-lg font-medium text-pretty text-gray-600 sm:text-xl/8"
          >
            Take registers, message parents, log achievements and stay on top of
            your schedule - all from one simple app.
          </p>
          <div
            class="mt-10 flex flex-col justify-start gap-y-2 gap-x-6 sm:flex-row sm:items-center"
          >
            <a
              href="https://apps.apple.com/ie/app/juniper-education/id6514314038"
              @click="trackAppStoreClick"
              target="_blank"
              rel="noopener noreferrer"
              class="rounded-md bg-gray-800 w-fit transition-colors px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs flex gap-2 items-center hover:bg-gray-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-300"
            >
              <i class="fa-brands fa-apple w-10 text-3xl"></i>
              <div class="flex flex-col">
                <small>Download from the</small>
                <span>App Store</span>
              </div>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.juniper.mobile.app"
              @click="trackGooglePlayClick"
              target="_blank"
              rel="noopener noreferrer"
              class="rounded-md bg-green-600 w-fit transition-colors px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs flex gap-2 items-center hover:bg-green-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
            >
              <i class="fa-brands fa-android w-10 text-3xl"></i>
              <div class="flex flex-col">
                <small>Download from</small>
                <span>Google Play</span>
              </div>
            </a>
          </div>
        </div>
        <div
          data-aos="fade-left"
          class="mt-16 sm:mt-24 lg:mt-0 lg:shrink-0 lg:grow"
        >
          <img
            src="/mockups/9.webp"
            class="mx-auto w-[22.875rem] max-w-full h-auto drop-shadow-xl"
            alt="Mobile mockup prototype"
            height="724"
            width="366"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import TextUnderline from "./TextUnderline.vue";
import { track } from "@vercel/analytics";

const trackAppStoreClick = () => {
  track("download_app", {
    platform: "ios",
    page: "teacher",
    component: "hero",
  });
};

const trackGooglePlayClick = () => {
  track("download_app", {
    platform: "android",
    page: "teacher",
    component: "hero",
  });
};
</script>
